import { FooterContainer } from './styles'

const Footer = () => {
  return (
    <FooterContainer>
      <h3>Kilder Advogados Assosiados</h3>
      <div>
        <p>© 2024 Kilder Advogados Assosiados. Todos os direitos reservados.</p>
        <p>
          Desenvolvido Por{' '}
          <a
            href="https://my-portfolio-danilo-felix.vercel.app/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Danilo Felix
          </a>
        </p>
      </div>
    </FooterContainer>
  )
}

export default Footer
